<!--  -->
<template>
  <div class="dividerPan">
    <el-divider content-position="left">{{ noticeInfo }}</el-divider>
  </div>
</template>

<script>
export default {
  props: {
    noticeInfo: String
  },
  data () {
    return {}
  }
}
</script>
<style scoped>
.dividerPan :deep(.el-divider--horizontal) {
  width: 140px;
}
</style>
